module.exports = __webpack_public_path__ + "static/media/order_dropdown_icon.4d86cd43.svg";